import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

const show = (id: number) => reactQueryGet(internalApi.site.pages.show(id));

export const pagesApi = { show };
